import React, { useState } from "react"
import { Box, Grid, Typography } from "@mui/material"

import * as Style from "./style"
import moment from "moment"
import { CiMail } from "react-icons/ci"
import { LuPhone } from "react-icons/lu"
import { FaPencilAlt } from "react-icons/fa"
import { Link } from "react-router-dom"
import { useAccountProfileQuery } from "../../features/Auth/authApi"
import { LuLock } from "react-icons/lu"
import CenteredSpinner from "../common/CenteredSpinner"
import ChangePasswordModal from "./ChangePasswordModal"
import dummy from "../../images/dummy-image.jpg"
import EditAccount from "./EditAccount"
const MyAccount = () => {
  const { data: dataList, isLoading } = useAccountProfileQuery({})
  const [open, setOpen] = useState(false)
  const [editView, setEditView] = useState<boolean>(true)

  const tagStyle = {
    border: "1px solid #F475A4",
    padding: "4px 8px",
    borderRadius: "8px",
    marginRight: "8px",
    marginBottom: "8px",
    display: "inline-block",
    backgroundColor: "#F475A4",
    color: " #fff",
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <Style.Overview>
          <Grid container>
            <Grid xs={12} md={5} lg={4} className="pe-2 pe-xl-4">
              <Box className="review-card text-center p-4 d-flex flex-column align-items-center h-100">
                <Box className="mb-4">
                  <img
                    src={dataList?.data?.profilePic || dummy}
                    className="profile-img-2"
                  />
                </Box>
                <Typography
                  variant="h2"
                  align="center"
                  className="mb-3 fw-bold"
                >
                  {dataList?.data?.name}
                </Typography>
                <Typography variant="body1" align="center" className="mb-3">
                  <CiMail /> {dataList?.data?.email}
                </Typography>
                <Typography variant="body1" align="center" className="mb-3">
                  <LuPhone /> {dataList?.data?.contactNo}
                </Typography>
                <Link
                  to=""
                  onClick={() => setEditView(!editView)}
                  className="view-profile mb-3"
                >
                  {editView ? (
                    <>
                      Edit <FaPencilAlt /></>
                  ): (
                    "Cancel"
                  )}
                </Link>

                <Link
                  to=""
                  className="view-profile mb-3"
                  onClick={() => setOpen(true)}
                >
                  Change Password <LuLock />
                </Link>
              </Box>
            </Grid>
            <Grid
              xs={12}
              md={7}
              lg={8}
              sx={{
                maxHeight: "80vh",
                overflowY: "auto",
                pr: 2,
              }}
            >
              {editView ? (
                <Box className="review-card p-3">
                  {[
                    { label: "Name", value: dataList?.data?.name },
                    { label: "E-Mail", value: dataList?.data?.email },
                    { label: "Phone Number", value: dataList?.data?.contactNo },
                    { label: "Gender", value: dataList?.data?.gender || "--" },
                    {
                      label: "Language",
                      value: dataList?.data?.language?.join(", ") || "--",
                    },
                    {
                      label: "Date Of Birth",
                      value: moment(dataList?.data?.dob).format("DD-MM-YYYY"),
                    },
                    { label: "Origin Country", value: dataList?.data?.region },
                    { label: "Location", value: dataList?.data?.address },
                    {
                      label: "Your Bio",
                      value: dataList?.data?.description || "--",
                    },
                  ].map((item, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        border: "1px solid #d3d3d3",
                        borderRadius: 2,
                        p: 2,
                        mb: 2,
                        overflowX: "auto",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        color="black"
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                  ))}

                  <Box
                    sx={{
                      border: "1px solid #d3d3d3",
                      borderRadius: 2,
                      p: 2,
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      fontWeight="bold"
                      color="black"
                    >
                      Services Offered
                    </Typography>
                    <Box
                      mt={1}
                      sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                    >
                      {dataList?.data?.services?.map((service: any) => (
                        <Box key={service.id} sx={tagStyle}>
                          {service.name}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              ) : (
                <EditAccount editView={editView} setEditView={setEditView} />
              )}
            </Grid>
          </Grid>
        </Style.Overview>
      )}

      <ChangePasswordModal opens={open} handleClose={handleClose} />
    </>
  )
}
export default MyAccount
